const configs = {
  'doughnut-pie': {
    w: 4,
    h: 4
  },
  'unfinished-plan-table': {
    w: 9,
    h: 4
  },
  'utilization-chart': {
    w: 6,
    h: 4
  },
  'device-status-table': {
    w: 6,
    h: 4
  },
  'device-alarm-table': {
    w: 6,
    h: 4
  },
  'employee-performance-table': {
    w: 6,
    h: 4
  },
  'work-record': {
    w: 4,
    h: 2
  },
  'regional-completion': {
    w: 4,
    h: 2
  },
  'pending-work': {
    w: 6,
    h: 2
  },
  'total-regions': {
    w: 4,
    h: 2
  },
  'threshold-rate-table': {
    w: 6,
    h: 2
  },
  'screening-customers-table': {
    w: 4,
    h: 2
  },
  'map-view': {
    w: 4,
    h: 4
  },
  'gateway-statue-record-card':{
    w: 6,
    h: 3
  },
  'gateway-overview-card':{
    w: 6,
    h: 3
  },
  'repeat-custom-device':{
    w: 6,
    h: 4
  },
  'inactive-device':{
    w: 6,
    h: 4
  }
}

export default configs
